<style lang="scss">
  @import '~@assets/scss/app';

  #app {
    min-height: 100%;
  }
</style>

<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import appConfig from '@src/app.config';

const baseUrl = process.env.VUE_APP_PUBLIC_PATH;
const darkMode = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;

export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate() {
      return appConfig.title;
    },
    link: {
      rel: 'shortcut icon',
      href: `${baseUrl}images/favicon/vk_favicon.ico`,
      ...(darkMode && { media: "(prefers-color-scheme: dark)" }),
    },
  },
};
</script>
